import React from 'react'
import IntegrationBanner from './IntegrationBanner'
import IntegrationPartner from './IntegrationPartner'
import IntegrationPost from './IntegrationPost'

export default function IntegtrationListing({ initialData }) {

  const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        slug: "",
        name: "Integrations"
      }
    ]
  }

  const partner = {
    subTitle: "Partner With Us",
    heading: "Looking For A <br/> Specific Integration?",
    description:
      "Can't find what you're looking for? We're constantly expanding our integration ecosystem. Reach out, we'll help you find exactly the right fit for you.",
    buttonText: "Request Integration",
    buttonLink: "/contact-us",
    bgImage: "/assets/images/integration-new-image.webp",
  }


  return (
    <>
      <IntegrationBanner breadcrumb={bannerData.breadcrumb} />
      <IntegrationPost initialData={initialData} />
      <IntegrationPartner data={partner} />
    </>
  )
}
